import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SeniorLivingLandingPage } from './pages/SeniorLivingLandingPage';
import { ThankYou } from './pages/ThankYou';
import { usePageTracking } from './hooks/usePageTracking';
function AppRoutes() {
  usePageTracking();
  return <Routes data-id="element-0" data-mp="3f9yi5idd8izo">
      <Route path="/" element={<SeniorLivingLandingPage data-id="element-2" data-mp="3fb14re3nnz9s" />} data-id="element-1" data-mp="3fa84mvz7c80m" />
      <Route path="/thank-you" element={<ThankYou data-id="element-4" data-mp="2rk4796clx4i2" />} data-id="element-3" data-mp="2rkx3vehuqdmh" />
    </Routes>;
}
export function App() {
  return <BrowserRouter data-id="element-5" data-mp="2mlua4q7bnttt">
      <AppRoutes data-id="element-6" data-mp="2mmcd05ohp6ap" />
    </BrowserRouter>;
}